module.exports = __webpack_public_path__ + "img/17.d42b0d8b.svg";